import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

export type ReimbursementListProvidersResponse = {
  providers: {
    providerId: string
    providerName: string
  }[]
}

export function useReimbursementsListProviders() {
  return useQuery<ReimbursementListProvidersResponse>({
    queryKey: ["Reimbursement/ListProviders"],
    queryFn: async () => {
      const response = await fetcher(
        "/Reimbursement/ListProviders",
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
    enabled: true,
  })
}
